/**
 * Andre Garen - urun sayfasi ekleri (Tur 23 EK10 \u00a73.2). Yalniz urun sayfasinda yuklenir. Anahtarli: deneme ogeleri
 * yalniz html.ag-deneme iken calisir (snippets/ag-ozellikler.liquid -> window.agOz).
 *  S020 beden stok noktalari: gercek stoktan (#ag-product-data inventoryQty) var / son 1-2 / yok; diger secili seceneklere gore.
 *  S025 On \u00b7 Arka \u00b7 Detay: urunun kendi fotograf sirasi (1., 2., 3. gorsel); ucten az fotografta sekme yok.
 *  S013 buyutec: yalniz basili tutunca (300 ms, kipirdamadan) acilir; 170 px, parmagin 90 px ustunde, 2,5x; galeri kaydirmasini bozmaz; parmak birakinca kapanir.
 *  S024 + D072 + S078 sepete ekleme ani: altin nokta sepete iner, ustte yapiskan sepet bandi (kucuk resim + Odemeye gec),
 *  d\u00f6n\u00fc\u015f\u00fcrken vapur bantta bir kez gecer. Hareket azaltmada yalniz bant (animasyon yok).
 */
(function () {
  'use strict';
  var D = document.documentElement;
  var oz = function (id) { return !!(window.agOz && window.agOz(id)); };
  var SAKIN = D.getAttribute('data-ag-calm') === '1' || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var veriEl = document.getElementById('ag-product-data');
  if (!veriEl) return;
  var P = null; try { P = JSON.parse(veriEl.textContent); } catch (e) { return; }

  /* ---------------- S020 beden stok noktalari ---------------- */
  function secili() {
    return P.optionNames.map(function (_, i) {
      var b = document.querySelector('.ag-product [data-ag-option-set="' + i + '"][aria-pressed="true"]');
      return b ? b.getAttribute('data-ag-value') : null;
    });
  }
  function noktalar() {
    if (!oz('S020')) return;
    var sel = secili();
    [].forEach.call(document.querySelectorAll('.ag-product .ag-size[data-ag-option-set]'), function (b) {
      var i = +b.getAttribute('data-ag-option-set'), deger = b.getAttribute('data-ag-value'), en = -1, yonetim = true;
      P.variants.forEach(function (v) {
        if (v.options[i] !== deger) return;
        for (var j = 0; j < sel.length; j++) if (j !== i && sel[j] != null && v.options[j] !== sel[j]) return;
        if (!v.available) { en = Math.max(en, 0); return; }
        if (!v.inventoryManaged) { yonetim = false; en = Math.max(en, 99); return; }
        en = Math.max(en, v.inventoryQty > 0 ? v.inventoryQty : 99);
      });
      var durum = en <= 0 ? 'yok' : (yonetim && en <= 2) ? 'az' : 'var';
      b.setAttribute('data-ag-stok', durum);
      if (!b.hasAttribute('data-ag-aria0')) b.setAttribute('data-ag-aria0', b.getAttribute('aria-label') || deger);
      b.setAttribute('aria-label', durum === 'az' ? deger + ', son ' + en : b.getAttribute('data-ag-aria0'));
    });
  }
  noktalar();
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.ag-product [data-ag-option-set]')) setTimeout(noktalar, 0); });

  /* ---------------- S025 On \u00b7 Arka \u00b7 Detay ---------------- */
  var sekme = document.querySelector('[data-ag-oad]');
  if (sekme && oz('S025')) {
    var gal = document.querySelector('[data-ag-gallery]');
    var ogeler = gal ? gal.querySelectorAll('.ag-gallery__item') : [];
    if (ogeler.length >= 3) {
      sekme.hidden = false;
      var dug = sekme.querySelectorAll('button');
      var git = function (i) {
        var it = ogeler[i]; if (!it) return;
        gal.scrollTo({ left: it.offsetLeft - gal.offsetLeft, behavior: SAKIN ? 'auto' : 'smooth' });
        [].forEach.call(dug, function (x, j) { x.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      };
      [].forEach.call(dug, function (x, j) { x.addEventListener('click', function () { git(j); }); });
      gal.addEventListener('scroll', function () {
        var i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
        [].forEach.call(dug, function (x, j) { x.setAttribute('aria-pressed', j === Math.min(i, 2) ? 'true' : 'false'); });
      }, { passive: true });
    }
  }

  /* ---------------- S013 buyutec (basili tutunca) ---------------- */
  var galeri = document.querySelector('[data-ag-gallery]');
  if (galeri && oz('S013')) {
    var lens = null, halka = null, zaman = null, bas = null, aktif = false, img = null;
    var kapat = function () { clearTimeout(zaman); aktif = false; if (lens) lens.hidden = true; if (halka) halka.hidden = true; };
    var konumla = function (x, y) {
      if (!lens || !img) return;
      var r = img.getBoundingClientRect(), k = 2.5, L = 170;
      var px = Math.max(0, Math.min(1, (x - r.left) / r.width)), py = Math.max(0, Math.min(1, (y - r.top) / r.height));
      lens.style.left = (x - L / 2) + 'px'; lens.style.top = (y - L - 90) + 'px';
      if (halka) { halka.style.left = (x - 22) + 'px'; halka.style.top = (y - 22) + 'px'; }
      lens.style.backgroundSize = (r.width * k) + 'px ' + (r.height * k) + 'px';
      lens.style.backgroundPosition = (-(px * r.width * k - L / 2)) + 'px ' + (-(py * r.height * k - L / 2)) + 'px';
    };
    galeri.addEventListener('touchstart', function (e) {
      var it = e.target.closest('.ag-gallery__item'); if (!it || e.touches.length !== 1) return;
      img = it.querySelector('img'); if (!img) return;
      bas = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      clearTimeout(zaman);
      zaman = setTimeout(function () {
        aktif = true;
        if (!lens) {
          lens = document.createElement('div'); lens.className = 'ag-buyutec'; lens.setAttribute('aria-hidden', 'true');
          lens.innerHTML = '<span class="ag-buyutec__x">2,5\u00d7</span>'; document.body.appendChild(lens);
          halka = document.createElement('span'); halka.className = 'ag-buyutec-halka'; halka.setAttribute('aria-hidden', 'true'); document.body.appendChild(halka);
        }
        halka.hidden = false;
        var z = it.querySelector('[data-ag-zoom-src]');
        lens.style.backgroundImage = 'url("' + ((z && z.getAttribute('data-ag-zoom-src')) || img.currentSrc || img.src) + '")';
        lens.hidden = false; konumla(bas.x, bas.y);
      }, 300);
    }, { passive: true });
    galeri.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      if (!aktif) { if (bas && (Math.abs(t.clientX - bas.x) > 8 || Math.abs(t.clientY - bas.y) > 8)) clearTimeout(zaman); return; }
      if (e.cancelable) e.preventDefault();
      konumla(t.clientX, t.clientY);
    }, { passive: false });
    galeri.addEventListener('touchend', kapat);
    galeri.addEventListener('touchcancel', kapat);
    galeri.addEventListener('contextmenu', function (e) { if (aktif) e.preventDefault(); });
  }

  /* Acilis gecesi: S016 "38 giyiyorsan bu parcada 40" cumlesi kalkti (beden metni tek: "Senin bedenin: M") */

  /* ---------------- S024 + D072 + S078 sepete ekleme ani ---------------- */
  var ekVeri = document.querySelector('[data-ag-urun-ek]');
  var sonAdet = null;
  try { sonAdet = parseInt((document.querySelector('[data-ag-cart-count]') || {}).textContent, 10); } catch (e) {}
  if (isNaN(sonAdet)) sonAdet = null;
  function bantKur(adet) {
    var b = document.querySelector('.ag-sepetbant');
    if (!b) {
      b = document.createElement('div'); b.className = 'ag-sepetbant'; b.setAttribute('role', 'region'); b.setAttribute('aria-label', 'Sepet');
      var foto = (document.querySelector('[data-ag-gallery] img') || {}).currentSrc || '';
      b.innerHTML = '<button type="button" class="ag-sepetbant__sepet" data-ag-sepetbant-ac><img alt="" width="32" height="32"><span class="ag-sepetbant__metin"></span></button>' +
        '<a class="ag-sepetbant__odeme" href="/checkout">\u00d6demeye ge\u00e7 <span aria-hidden="true">\u2192</span></a><span class="ag-sepetbant__vapur" aria-hidden="true"></span>';
      if (foto) b.querySelector('img').src = foto; else b.querySelector('img').remove();
      if (ekVeri) { b.style.setProperty('--ag-vapur', 'url("' + ekVeri.getAttribute('data-vapur') + '")'); if (ekVeri.getAttribute('data-korfez')) b.style.setProperty('--ag-korfez', 'url("' + ekVeri.getAttribute('data-korfez') + '")'); }
      document.body.appendChild(b);
      b.querySelector('[data-ag-sepetbant-ac]').addEventListener('click', function () { if (window.AGCart && window.AGCart.open) window.AGCart.open(); });
      D.classList.add('ag-sepetbant-var');
    }
    b.querySelector('.ag-sepetbant__metin').textContent = 'SEPET\u0130NDE ' + adet + ' PAR\u00c7A';
    b.querySelector('.ag-sepetbant__sepet').setAttribute('aria-label', 'Sepetinde ' + adet + ' par\u00e7a, sepeti a\u00e7');
    try { sessionStorage.setItem('ag:sepetbant', '1'); } catch (e) {}
    return b;
  }
  function nokta() {
    var bas = document.querySelector('.ag-product [data-ag-add]'), hedef = document.querySelector('[data-ag-bb] [data-ag-cart-open], [data-ag-bb] a[href$="/cart"], .ag-header [data-ag-cart-open]');
    if (!bas || !hedef || !document.body.animate) return;
    var r0 = bas.getBoundingClientRect(), r1 = hedef.getBoundingClientRect();
    var n = document.createElement('span'); n.className = 'ag-altin-nokta'; n.setAttribute('aria-hidden', 'true');
    n.style.left = (r0.left + r0.width / 2 - 6) + 'px'; n.style.top = (r0.top + r0.height / 2 - 6) + 'px';
    document.body.appendChild(n);
    var dx = r1.left + r1.width / 2 - (r0.left + r0.width / 2), dy = r1.top + r1.height / 2 - (r0.top + r0.height / 2);
    var a = n.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + dx * .5 + 'px,' + (Math.min(dy, 0) - 80) + 'px) scale(1.1)', opacity: 1, offset: .45 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.5)', opacity: .2 }], { duration: 650, easing: 'cubic-bezier(.4,0,.2,1)' });
    a.onfinish = function () { n.remove(); };
  }
  if (oz('S024')) {
    [].forEach.call(document.querySelectorAll('.ag-product [data-ag-add], [data-ag-stickyatc] [data-ag-add]'), function (x) { x.setAttribute('data-ag-open-drawer', 'false'); });
    var ilkOturum = true; try { ilkOturum = sessionStorage.getItem('ag:sepetbant') !== '1'; if (!ilkOturum && sonAdet > 0) bantKur(sonAdet); } catch (e) {}
    document.addEventListener('ag:cart:updated', function (e) {
      var adet = e.detail && e.detail.count;
      if (adet == null) return;
      var artti = sonAdet != null && adet > sonAdet; sonAdet = adet;
      if (!adet) { var b0 = document.querySelector('.ag-sepetbant'); if (b0) { b0.remove(); D.classList.remove('ag-sepetbant-var'); } return; }
      if (!artti) { if (document.querySelector('.ag-sepetbant')) bantKur(adet); return; }
      var b = bantKur(adet);
      if (SAKIN) return;
      nokta();
      if (ilkOturum) {
        ilkOturum = false;
        var v = b.querySelector('.ag-sepetbant__vapur');
        if (v && v.animate) v.animate([{ transform: 'translateX(-60px)', opacity: 1 }, { transform: 'translateX(' + (innerWidth + 10) + 'px)', opacity: 1 }], { duration: 1200, easing: 'linear' });
      }
    });
  }

  /* ---------------- S019 Bu parcayla: "Ikisini sepete ekle" (plan uyum, S019.png) ----------------
     Bu urunun secili varyanti (beden secilmediyse once beden istenir) + es parcanin tek stoklu varyanti ya da secilen bedeni. */
  var ikili = document.querySelector('[data-ag-ikili]');
  if (ikili) {
    var ikiBtn = ikili.querySelector('[data-ag-ikili-ekle]'), ikiDurum = ikili.querySelector('[data-ag-ikili-durum]');
    ikiBtn.addEventListener('click', function () {
      var ana = document.querySelector('.ag-product [data-ag-add]'), id1 = ana && ana.getAttribute('data-ag-add');
      if (!id1) {
        ikiDurum.textContent = '\u00d6nce bu par\u00e7an\u0131n bedenini se\u00e7.';
        var sr = document.querySelector('.ag-product [data-ag-size-row]');
        if (sr) { sr.scrollIntoView({ block: 'center', behavior: SAKIN ? 'auto' : 'smooth' }); var f = sr.querySelector('.ag-size:not(.ag-size--out)'); if (f) f.focus({ preventScroll: true }); }
        return;
      }
      var vs = ikili.querySelector('[data-ag-ikili-varyant]'), id2 = vs ? vs.value : ikili.getAttribute('data-ag-ikili-tek');
      if (!id2) { ikiDurum.textContent = 'E\u015f par\u00e7an\u0131n bedenini se\u00e7.'; if (vs) vs.focus(); return; }
      ikiBtn.disabled = true; ikiDurum.textContent = 'Ekleniyor\u2026';
      var it = [{ id: Number(id1), quantity: 1 }, { id: Number(id2), quantity: 1 }];
      var istek = window.AGCart && window.AGCart.add ? window.AGCart.add(it) : fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: it }) }).then(function (r) { if (!r.ok) throw 0; });
      istek.then(function () { ikiBtn.disabled = false; ikiDurum.textContent = '\u0130kisi de sepetinde.'; },
        function () { ikiBtn.disabled = false; ikiDurum.textContent = 'Eklenemedi; par\u00e7alardan biri az \u00f6nce t\u00fckenmi\u015f olabilir.'; });
    });
  }
})();

/* Acilis gecesi P0-8: urun adi 28 px'ten baslar, tek satira sigana kadar en az 17 px'e kuculur; 17 px'te de sigmazsa en cok 2 satir (balance) */
(function () {
  'use strict';
  var t = document.querySelector('.ag-product__title');
  function sigdir() {
    if (!t) return; var fs = 28; t.style.whiteSpace = 'nowrap'; t.style.fontSize = fs + 'px';
    while (t.scrollWidth > t.clientWidth + 1 && fs > 17) { fs -= 1; t.style.fontSize = fs + 'px'; }
    if (t.scrollWidth > t.clientWidth + 1) t.style.whiteSpace = 'normal';
  }
  if (t) { sigdir(); window.addEventListener('resize', sigdir); if (document.fonts && document.fonts.ready) document.fonts.ready.then(sigdir); }
  document.addEventListener('contextmenu', function (e) { var t = e.target; if (t && t.closest && t.closest('[data-ag-gallery], [data-ag-gallery-zoom], [data-ag-gallery-thumbs], .ag-product__media, [data-ag-zoom], [data-ag-zoom-src], .ag-zoom, .ag-lightbox')) e.preventDefault(); }, true);
})();
